var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.activateClass},[_c('a',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('activate-tab', _vm.item.key)}}},[_vm._v(_vm._s(_vm.item.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56356fda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/TabsListItem.vue
// module id = GNTR
// module chunks = 0